
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import * as n from "@/types/notifications";

export type TroubleshootingValue = { title: string; tabTitle: string };

@Component
export default class TroubleshootingModal extends Vue {
  tab = null;

  @Prop()
  value!: TroubleshootingValue;

  @Prop()
  requestDetails!: n.RequestDetails;

  get hasCustomContent() {
    return this.$slots.default?.length;
  }

  get hasCustomMessage() {
    return this.$slots.message?.length;
  }

  get customTabTitle() {
    return this.value.tabTitle ?? "Content";
  }
}
